// import { EmployeeList } from "components/Employee";
import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { EmployeeList } from "../../components/EmployeeList";


export interface IEmployeeListPage {}

export const EmployeeListPage: FC<IEmployeeListPage> = (
  props: IEmployeeListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Employee List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/employee/list" },
      ]}
      mainContents={<EmployeeList />}
    />
  );
};
